export class ValidationError extends Error {
  constructor(message, { issues = [], raw = null, kind = "ZOD_VALIDATION_ERROR" } = {}) {
    super(message);
    this.name = "ValidationError";
    this.kind = kind;
    this.issues = issues;
    this.raw = raw;
  }
}

